export const translations = {
  ar: {
    meta: { title: "تفكَّر Tafakar | صحة أكثر، حياة أكثر" },
    common: { rateLimited: "لقد أرسلت طلبات كثيرة، يرجى المحاولة بعد قليل." },
    nav: {
      home: "الرئيسية",
      company: "عن الشركة",
      tafaker: "تطبيق تفكَّر",
      contact: "تواصل معنا",
      join: "انضم للانتظار",
      brand: "تفكَّر",
      brandSub: "قوة الحرية المثالية للتجارة",
    },
    hero: {
      badge: "قريباً — تطبيق تفكَّر",
      titleLines: ["صحة أكثر،", "حياة أكثر."],
      subtitle:
        "منصة ذكية واحدة تساعدك على تعزيز صحتك البدنية والنفسية من خلال تجربة ممتعة وسهلة، تحوّل نمط الحياة الصحي إلى رحلة يومية ملهمة مع مجتمع يشاركك الهدف.",
      ctaPrimary: "انضم إلى قائمة الانتظار",
      ctaSecondary: "اكتشف تفكَّر",
      card1Title: "جسد + عقل",
      card1Sub: "توازن متكامل في مكان واحد",
      card2Title: "مجتمع تفاعلي",
      card2Sub: "أهداف مشتركة وحماس متبادل",
      scroll: "اسحب للأسفل",
    },
    marquee: ["صحة بدنية", "صفاء ذهني", "عادات يومية", "مجتمع تفاعلي", "جودة حياة", "أهداف مشتركة"],
    phone: { tagline: "صحة أكثر، حياة أكثر" },
    intro: {
      eyebrow: "التطبيق",
      title: "تطبيق واحد… حياة كاملة",
      lead: "منصة جديدة لتعزيز الوعي الصحي",
      p1: "تفكَّر تجمع المعرفة والأدوات والتجربة في مساحة واحدة، لتساعدك على اتخاذ قرارات أفضل وبناء أسلوب حياة أكثر صحة وتوازنًا.",
      p2: "ليست الفكرة أن تعيش وفق قواعد أكثر، بل أن تفهم أكثر لتختار ما يناسبك.",
      chips: ["تغذية", "تمارين", "تواصل اجتماعي", "دعم"],
      cta: "كن من أوائل التجربة",
    },
    diff: {
      eyebrow: "لماذا تفكَّر؟",
      title: "مختلفون عن كل ما جرّبت",
      subtitle: "ثلاثة مبادئ تجعل تفكَّر تجربة لا تشبه غيرها",
      items: [
        {
          title: "وعي متكامل",
          desc: "نهتم بصحة الجسد والعقل معًا، لأنها أساس التوازن.",
        },
        {
          title: "مجتمع داعم",
          desc: "مساحة أسهل للتواصل مع أشخاص يشاركونك نفس الأهداف.",
        },
        {
          title: "أسلوب حياة",
          desc: "نساعدك على بناء عادات صحية تستطيع الاستمرار عليها.",
        },
      ],
    },
    tafaker: {
      eyebrow: "منصة تفكَّر",
      title: "فلسفتنا في ثلاثة فصول",
      chapters: [
        {
          num: "01",
          title: "المشكلة التي نحلها",
          text: "كثيرون يفقدون حماسهم أمام أدوات صحية مجزأة: تطبيق للتمارين، وآخر للتأمل، وثالث للعادات. تشتّت يجعل الالتزام عبئاً. نؤمن أن الحياة الصحية يجب أن تكون متعة يومية — لا مهمة شاقة.",
        },
        {
          num: "02",
          title: "الحل الموحّد",
          text: "تفكَّر يجمع التمارين والتأمل والعادات اليومية والتفاعل المجتمعي في منصة واحدة أنيقة. كل ما تحتاجه لصحة بدنية وذهنية متوازنة، في مكان واحد، بتجربة بسيطة وممتعة.",
        },
        {
          num: "03",
          title: "شراكات محلية وعالمية",
          text: "نبني شراكات استراتيجية مع الجهات الصحية والمؤسسات التعليمية والشركات، لخلق منظومة متكاملة ترفع جودة الحياة — محلياً وعالمياً.",
        },
      ],
      ai: {
        badge: "القادم",
        title: "ذكاء اصطناعي يعرف إيقاعك",
        text: "في المرحلة القادمة، يندمج الذكاء الاصطناعي في قلب تفكَّر ليصبح مساعدك الشخصي: يفهم احتياجاتك، يتعلم من عاداتك، ويرافقك بتوصيات مصممة لك وحدك.",
      },
      partnerCta: "مهتم بالشراكة؟ لنتحدث",
    },
    company: {
      eyebrow: "من نحن",
      name: "شركة قوة الحرية المثالية للتجارة",
      tagline: "معاً نحو حياة أكثر صحة",
      storyTitle: "نؤمن بأن الإنسان يستحق أن يعيش حياة أكثر صحة، ووعيًا، وجودة.",
      storyText:
        "ومن هنا تأسست الشركة لتطوير وتقديم سلع وخدمات تمنح الأشخاص المعرفة والأدوات التي تساعدهم على اتخاذ قرارات تخدم صحتهم وحياتهم، وتجعل أسلوب الحياة الصحي أسهل وأكثر متعة. ويأتي تطبيق تفكَّر كأولى خطواتنا نحو تحقيق هذه الرؤية.",
      quote: "«التغيير الحقيقي يبدأ بقرار حقيقي»",
      values: ["الأصالة والتأثير الحقيقي", "الابتكار في تقنيات الصحة", "الالتزام بجودة الحياة"],
      missionTitle: "رسالتنا",
      mission: "تمكين الجميع من التمتع بصحة أفضل، من خلال سلع وخدمات تجعل أسلوب الحياة الصحي أسهل وأكثر متعة.",
    },
    profile: {
      missionLabel: "مهمتنا",
      mission: "نحو حياة أكثر صحة.",
      messageLabel: "رسالتنا",
      message: "تمكين الأشخاص من التمتع بصحة أفضل، من خلال سلع وخدمات تجعل من أسلوب الحياة الصحي أكثر متعة وسهولة.",
      valuesEyebrow: "قيمنا",
      valuesTitle: "ما يحركنا كل يوم؟",
      values: [
        { title: "الشغف", desc: "هو الوقود الذي يقود مهمتنا، ويدفعنا لصناعة أثر حقيقي." },
        { title: "الصراحة", desc: "نتصرف بحرية، ونتواصل بنزاهة وصدق." },
        { title: "الرغبة في النمو والتطور", desc: "نسعى باستمرار للتعلم والتطور، وتعزيز السلوكيات الإيجابية والصحية في كل مكان." },
        { title: "ريادة الأعمال", desc: "نؤمن بالمبادرة وخلق الفرص، وتحويل الأفكار إلى قيمة مستدامة." },
        { title: "المسؤولية", desc: "نتحمل مسؤولية قراراتنا وتحدياتنا، ونمضي بكل ما نملك نحو تحقيق مهمتنا." },
        { title: "التمكين", desc: "نُمكّن الأشخاص بالمعرفة والأدوات التي تساعدهم على اتخاذ قرارات أفضل لصحتهم وحياتهم." },
      ],
    },
    contact: {
      eyebrow: "تواصل",
      title: "معاً نحو حياة أكثر صحة",
      subtitle: "للاستفسارات والشراكات",
      name: "الاسم الكامل",
      namePh: "اكتب اسمك",
      email: "البريد الإلكتروني",
      emailPh: "name@example.com",
      subject: "الموضوع",
      subjectPh: "بمَ يتعلق تواصلك؟",
      message: "الرسالة",
      messagePh: "اكتب رسالتك هنا…",
      submit: "إرسال الرسالة",
      sending: "جارٍ الإرسال…",
      success: "وصلتنا رسالتك — سنعود إليك قريباً",
      error: "حدث خطأ، حاول مرة أخرى",
      emailLabel: "راسلنا مباشرة",
      emailValue: "info@powerof-freedom.com",
      phoneLabel: "اتصل بنا",
      note: "يتم الرد عادة خلال 48 ساعة",
    },
    waitlist: {
      title: "كن أول من يجرّب تفكَّر",
      desc: "انضم إلى قائمة الانتظار وسنُعلمك فور إطلاق التطبيق، مع أولوية الوصول المبكر.",
      namePh: "الاسم (اختياري)",
      emailPh: "بريدك الإلكتروني",
      submit: "أعلمني عند الإطلاق",
      joining: "لحظات…",
      success: "أهلاً بك في الرحلة! سنبقيك على اطلاع",
      exists: "أنت مسجل مسبقاً — سنعلمك أولاً",
      error: "تعذّر التسجيل، حاول مجدداً",
    },
    footer: {
      tagline: "نحو حياة أكثر صحة",
      desc: "منصة تفكَّر — من تطوير شركة قوة الحرية المثالية للتجارة.",
      rights: "شركة قوة الحرية المثالية للتجارة. جميع الحقوق محفوظة.",
      navTitle: "الأقسام",
      terms: "شروط الاستخدام",
      privacy: "سياسة الخصوصية",
      address: "الأردن - عمان",
    },
  },
  en: {
    meta: { title: "Tafakar | More health, more life" },
    common: { rateLimited: "Too many requests — please try again in a few minutes." },
    nav: {
      home: "Home",
      company: "About the Company",
      tafaker: "Tafakar App",
      contact: "Contact",
      join: "Join Waitlist",
      brand: "Tafakar",
      brandSub: "The Ultimate Power of Freedom for Trading",
    },
    hero: {
      badge: "Coming soon — the Tafakar app",
      titleLines: ["More health,", "more life."],
      subtitle:
        "One smart platform that helps you strengthen your physical and mental health through an enjoyable, effortless experience, turning healthy living into a daily journey with a community that shares your goals.",
      ctaPrimary: "Join the Waitlist",
      ctaSecondary: "Discover Tafakar",
      card1Title: "Body + Mind",
      card1Sub: "Complete balance in one place",
      card2Title: "Interactive Community",
      card2Sub: "Shared goals, mutual drive",
      scroll: "Scroll down",
    },
    marquee: ["Physical Health", "Mental Clarity", "Daily Habits", "Interactive Community", "Quality of Life", "Shared Goals"],
    phone: { tagline: "More health, more life" },
    intro: {
      eyebrow: "The App",
      title: "One app… a whole life",
      lead: "A new platform for greater health awareness",
      p1: "Tafakar brings knowledge, tools, and experience together in one space, helping you make better decisions and build a healthier, more balanced lifestyle.",
      p2: "The idea isn't to live by more rules, but to understand more so you can choose what suits you.",
      chips: ["Nutrition", "Workouts", "Social Connection", "Support"],
      cta: "Be among the first",
    },
    diff: {
      eyebrow: "Why Tafakar?",
      title: "Unlike anything you've tried",
      subtitle: "Three principles that make Tafakar a different kind of experience",
      items: [
        {
          title: "Integrated Awareness",
          desc: "We care for the health of body and mind together, because it is the foundation of balance.",
        },
        {
          title: "Supportive Community",
          desc: "An easier space to connect with people who share your goals.",
        },
        {
          title: "A Lifestyle",
          desc: "We help you build healthy habits you can actually sustain.",
        },
      ],
    },
    tafaker: {
      eyebrow: "The Tafakar Platform",
      title: "Our philosophy in three chapters",
      chapters: [
        {
          num: "01",
          title: "The problem we solve",
          text: "Many lose motivation facing fragmented health tools: one app for workouts, another for meditation, a third for habits. Fragmentation turns commitment into a burden. We believe healthy living should be a daily joy — not a chore.",
        },
        {
          num: "02",
          title: "The unified solution",
          text: "Tafakar brings workouts, mindfulness, daily habits, and community interaction into one elegant platform. Everything you need for balanced physical and mental health — in one place, with a simple, delightful experience.",
        },
        {
          num: "03",
          title: "Local & global partnerships",
          text: "We build strategic partnerships with health organizations, educational institutions, and companies — creating an integrated ecosystem that raises quality of life, locally and globally.",
        },
      ],
      ai: {
        badge: "Coming Next",
        title: "AI that knows your rhythm",
        text: "Next, artificial intelligence merges into the heart of Tafakar as your personal assistant: understanding your needs, learning your habits, and accompanying you with recommendations designed for you alone.",
      },
      partnerCta: "Interested in partnering? Let's talk",
    },
    company: {
      eyebrow: "Who We Are",
      name: "The Ultimate Power of Freedom for Trading",
      tagline: "Together towards a healthier life",
      storyTitle: "We believe every person deserves a healthier, more conscious, higher-quality life.",
      storyText:
        "From this belief the company was founded to develop and deliver goods and services that give people the knowledge and tools to make decisions that serve their health and lives, and make a healthy lifestyle easier and more enjoyable. The Tafakar app is our first step towards realizing this vision.",
      quote: "\u201CReal change begins with a real decision\u201D",
      values: ["Authenticity & Real Impact", "Health-Tech Innovation", "Quality-of-Life Commitment"],
      missionTitle: "Our Message",
      mission: "Empowering everyone to enjoy better health through goods and services that make a healthy lifestyle easier and more enjoyable.",
    },
    profile: {
      missionLabel: "Our Mission",
      mission: "Towards a healthier life.",
      messageLabel: "Our Message",
      message: "Empowering people to enjoy better health through goods and services that make a healthy lifestyle more enjoyable and easier.",
      valuesEyebrow: "Our Values",
      valuesTitle: "What drives us every day?",
      values: [
        { title: "Passion", desc: "The fuel that drives our mission and pushes us to create real impact." },
        { title: "Candor", desc: "We act freely and communicate with integrity and honesty." },
        { title: "Growth Mindset", desc: "We continuously learn and evolve, promoting positive, healthy behaviors everywhere." },
        { title: "Entrepreneurship", desc: "We believe in initiative, creating opportunities, and turning ideas into sustainable value." },
        { title: "Responsibility", desc: "We own our decisions and challenges, and give everything we have to achieve our mission." },
        { title: "Empowerment", desc: "We empower people with the knowledge and tools that help them make better decisions for their health and lives." },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Together towards a healthier life",
      subtitle: "For inquiries and partnerships",
      name: "Full name",
      namePh: "Your name",
      email: "Email",
      emailPh: "name@example.com",
      subject: "Subject",
      subjectPh: "What is this about?",
      message: "Message",
      messagePh: "Write your message…",
      submit: "Send Message",
      sending: "Sending…",
      success: "Message received — we'll get back to you soon",
      error: "Something went wrong, please try again",
      emailLabel: "Email us directly",
      emailValue: "info@powerof-freedom.com",
      phoneLabel: "Call us",
      note: "We usually reply within 48 hours",
    },
    waitlist: {
      title: "Be the first to try Tafakar",
      desc: "Join the waitlist and we'll notify you the moment the app launches — with early access priority.",
      namePh: "Name (optional)",
      emailPh: "Your email",
      submit: "Notify me at launch",
      joining: "One moment…",
      success: "Welcome to the journey! We'll keep you posted",
      exists: "You're already on the list — you'll be first to know",
      error: "Couldn't register, please try again",
    },
    footer: {
      tagline: "Towards a healthier life",
      desc: "The Tafakar platform — developed by The Ultimate Power of Freedom for Trading.",
      rights: "The Ultimate Power of Freedom for Trading. All rights reserved.",
      navTitle: "Sections",
      terms: "Terms of Use",
      privacy: "Privacy Policy",
      address: "Amman, Jordan",
    },
  },
};
